import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from '../../../../../../../common/react/components/select';
import { getTranslation } from '../../../../../../../common/react/utils/translations';
import { statsLeadersNavSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors/nav-selector';
import { STATS_LEADERS_CATEGORY_ARRAY } from '../config/categories';

export const CategoryNavItem = ( { updateNavSelection } ) => {
    const nav = useSelector( statsLeadersNavSelector );

    return (
        <Select
            items={ STATS_LEADERS_CATEGORY_ARRAY }
            initialSelectedItem={ nav.category }
            activeItem={ nav.category }
            label={ getTranslation( 'label.statsLeaders.nav.category' ) }
            onSelectedItemChange={ ( { selectedItem: category } ) => {
                updateNavSelection( 'category', category );
            } }
        />
    );
};

CategoryNavItem.propTypes = {
    updateNavSelection: PropTypes.func.isRequired
};